import {useState, useEffect} from "react";
import {Table, Modal, Button, Tabs} from 'antd';
import moment from "moment"

import PageHeading from "../../shared/containers/PageHeading";

import {payColumns, paidColumns, renderPayDetails, cancelColumns, outstandingColumns} from "./table";

import useTableData from "../../shared/hooks/useTableData";

import {getAllPay, getAllPaid, updateById, getAllCancel, getAllOutstanding} from "../../shared/services/earning";

import styles from "./earning.module.scss";

const EarningPage = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [confirmStatus, setConfirmStatus] = useState(false);
    const [updateApprove, setUpdateApprove] = useState(null);
    const [updateData, setUpdateData] = useState(null);

    const updateStatus = (id, newStatus) => {
        setConfirmStatus(true);
        setUpdateApprove({id, newStatus});
    }

    const createUpdateData = (type) => {
        if(type === "confirm") {
            setUpdateData(updateApprove);
        }
        else {
            setUpdateApprove(null);
        }
        setConfirmStatus(false)
    }

    const {
        data: payData,
        setData: setPayData,
        loading: payLoading,
        pagination: payPagination,
        handleChange: payHandleChange,
    } = useTableData({fetchData: getAllPay});

    const {
        data: paidData,
        setData: setPaidData,
        loading: paidLoading,
        pagination: paidPagination,
        handleChange: paidHandleChange,
    } = useTableData({fetchData: getAllPaid});

    const {
        data: cancelData,
        setData: setCancelData,
        loading: cancelLoading,
        pagination: cancelPagination,
        handleChange: cancelHandleChange,
    } = useTableData({fetchData: getAllCancel});

    const {
        data: outstandingData,
        loading: outstandingLoading,
        pagination: outstandingPagination,
        handleChange: outstandingHandleChange,
    } = useTableData({fetchData: getAllOutstanding});

    useEffect(()=>{
        const update = async() => {
            try {
                const {id, newStatus} = updateData;
                await updateById(id, {newStatus});
                const addData = payData.hits.find(item => item.id === id);
                setPayData(prevData => {
                    const newHits = prevData.hits.filter(item => item.id !== id);

                    return {...prevData, hits: newHits}
                })
                console.log(newStatus)
                if(newStatus === "paid") {
                    setPaidData(prevData => ({...prevData, hits: [addData, ...prevData.hits]}))
                } else {
                    setCancelData(prevData => ({...prevData, hits: [addData, ...prevData.hits]}))
                }

                setUpdateApprove(null);
                setUpdateData(null);
            }
            catch(error) {
                setUpdateApprove(null);
                setUpdateData(null);
                console.log(error.message)
            }
        }
        if(updateData) {
            update();
        }
    }, [updateData])

    const showDetails = (id, type) => {
        setModalOpen(true);
        let element;
        if(type === "Pay") {
            element = payData.hits.find(item => item.id === id);
        } else if (type === "Paid") {
            element = paidData.hits.find(item => item.id === id);
        } else {
            element = cancelData.hits.find(item => item.id === id);
        }
        console.log(element)
        setModalContent({...element, type});
    }

    const columnsPayConfig = [...payColumns];
    const columnsPaidConfig = [...paidColumns];
    const columnsCancelConfig = [...cancelColumns];

    const {hits: payHits} = payData;
    columnsPayConfig[3].render = renderPayDetails(showDetails, updateStatus);

    const {hits: paidHits} = paidData;
    columnsPaidConfig[3].render = (_, record)=> <span className="user-link" onClick={() => showDetails(record.id, "Paid")}>View</span>

    const {hits: cancelHits} = cancelData;
    columnsCancelConfig[3].render = (_, record)=> <span className="user-link" onClick={() => showDetails(record.id, "Cancel")}>View</span>

    return (
        <>
            <PageHeading title="Payment"/>
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Outstanding" key="0">
                    <Table columns={outstandingColumns} dataSource={outstandingData.hits} loading={outstandingLoading}
                           pagination={outstandingPagination} onChange={outstandingHandleChange} scroll={{x: 1230}}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Pay" key="1">
                    <Table columns={columnsPayConfig} dataSource={payHits} loading={payLoading} pagination={payPagination}
                           onChange={payHandleChange}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Paid" key="2">
                    <Table columns={columnsPaidConfig} dataSource={paidHits} loading={paidLoading} pagination={paidPagination}
                           onChange={paidHandleChange}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Canceled" key="3">
                    <Table columns={columnsCancelConfig} dataSource={cancelHits} loading={cancelLoading} pagination={cancelPagination}
                           onChange={cancelHandleChange}/>
                </Tabs.TabPane>
            </Tabs>

            <Modal open={confirmStatus} onCancel={() => setConfirmStatus(false)} footer={null}>
                <h2 className={styles.title}>Confirm {updateApprove?.newStatus}</h2>
                <div className={styles.actions}>
                    <Button onClick={()=> createUpdateData("confirm")} type="default"  style={{borderRadius: "4px", cursor: "pointer", color: "#52c41a", borderColor: "#52c41a"}}>
                        Confirm
                    </Button>
                    <Button onClick={()=> createUpdateData("cancel")} type="default" danger style={{borderRadius: "4px", cursor: "pointer"}}>
                        Decline
                    </Button>
                </div>
            </Modal>

            <Modal open={modalOpen} onCancel={() => setModalOpen(false)} footer={null}>
                {modalContent.user && (
                    <>
                        <h2 className={styles.title}>Payment details</h2>
                        <div className={styles.block}>
                            <div>
                                <p className={styles.subtitle}>User</p>
                                <p className={styles.text}>{`${modalContent.user.first_name} ${modalContent.user.last_name}`}</p>
                            </div>
                            <div>
                                <p className={styles.subtitle}>Status</p>
                                <p className={styles.text}>{modalContent.type}</p>
                            </div>
                        </div>

                        <div className={styles.block}>
                            <div>
                                <p className={styles.subtitle}>Email</p>
                                <p className={styles.text}>{modalContent.user.email}</p>
                            </div>
                            <div>
                                <p className={styles.subtitle}>Amount</p>
                                <p className={styles.text}>{modalContent.price} USD</p>
                            </div>
                        </div>

                        <div className={styles.block}>
                            <div>
                                <p className={styles.subtitle}>Phone</p>
                                <p className={styles.text}>{modalContent.user.phone}</p>
                            </div>
                            <div>
                                <p className={styles.subtitle}>Address</p>
                                <p className={styles.text}>{modalContent.user.address}</p>
                            </div>
                        </div>

                        <div className={styles.block}>
                            <div>
                                <p className={styles.subtitle}>Date and time</p>
                                <p className={styles.text}>{moment(modalContent.user.date).format('MMMM Do YYYY, h:mm')}</p>
                            </div>
                        </div>
                    </>
                )}
            </Modal>
        </>
    )
}

export default EarningPage;
